import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export const ombreLegere = "0 2px 12px rgba(0, 0, 0, 0.06)";

// Carte de statistique du module Sacrifices : icône dans une pastille pastel + chiffre en gras
function SacrificesCarteStat({ icon, label, valeur, color, children }) {
  return (
    <Card sx={{ boxShadow: ombreLegere, border: "1px solid " + color + "22", height: "100%" }}>
      <MDBox display="flex" alignItems="center" gap={2} p={2}>
        <MDBox
          display="flex" alignItems="center" justifyContent="center" flexShrink={0}
          sx={{ width: 52, height: 52, borderRadius: "12px", bgcolor: color + "1f", color }}
        >
          <Icon fontSize="medium">{icon}</Icon>
        </MDBox>
        <MDBox minWidth={0}>
          <MDTypography variant="caption" color="text" display="block" noWrap>{label}</MDTypography>
          <MDTypography variant="h4" fontWeight="bold" sx={{ color, lineHeight: 1.2 }}>{valeur}</MDTypography>
        </MDBox>
      </MDBox>
      {children}
    </Card>
  );
}

SacrificesCarteStat.defaultProps = { children: null };

SacrificesCarteStat.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  valeur: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default SacrificesCarteStat;
